<script>
  // from App converts routes to states uses props sectionId, listId and newsletterId
  import { sectionId, listId, newsletterId, isDisplayIssue } from './stores.js';
  export let sectionIdRoute
  export let listIdRoute
  export let newsletterIdRoute
  
  $: if (sectionIdRoute){
    console.log('@Route2State sectionIdRoute='+sectionIdRoute)
    sectionId.set(sectionIdRoute);
  }
  $: if (listIdRoute){
    console.log('@Route2State listIdRoute='+listIdRoute)
    listId.set(listIdRoute);
    isDisplayIssue.set(false);
  }
  $: if (newsletterIdRoute){
    console.log('@Route2State newsletterIdRoute='+newsletterIdRoute)
    newsletterId.set(newsletterIdRoute);
    isDisplayIssue.set(true);
  }
  
  console.log('@Route2State listId='+$listId+'  newsletterId='+$newsletterId+'   isDisplayIssue='+$isDisplayIssue)
</script>